import { getEnv } from '../environment';
import request from './request';

export type PriceLockEligibilityResponse = {
  eligible: boolean;
};

export const getPriceLockEligibility = (): Promise<PriceLockEligibilityResponse> =>
  request({
    path: `${getEnv().REACT_APP_GROWTH_URL}/api/1/price/lock/is-eligible`,
  }) as Promise<PriceLockEligibilityResponse>;
